import { UIEvent } from 'react';

/**
 * Elements takes sometimes milliseconds to appear, hence
 * this allows retrieving a DOM element asynchronous using its selector
 * @param selector
 */
export const waitForElement = (selector: string): Promise<Element | null> => {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
};

export const handleScrollEnd = (
  event: UIEvent<HTMLElement>,
  callback: () => void,
  options: {
    loading?: boolean;
    scrollOffset?: number;
  } = {},
) => {
  const { loading, scrollOffset } = options;

  const listboxNode = event.currentTarget;

  const hasReachedBottom =
    listboxNode.scrollTop + listboxNode.offsetHeight >= listboxNode.scrollHeight - (scrollOffset ?? 0);

  if (!hasReachedBottom || loading) return;

  callback();
};
